import React from "react";
import Card from "react-bootstrap/Card";
import ShowMoreText from "react-show-more-text";
import projImg6 from "../../assets/img/6.png";
import projectimage6 from "../../assets/img/p6.png";

const PreviousCard6 = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>The fractal structure of treelines in high mountains</h2></Card.Title> */}

        <Card.Img variant="top" src={projectimage6} />

        <Card.Body>
          <Card.Text>
            {" "}
            <img className="img2" src={projImg6} />{" "}
            <p className="text7">Beáta Oborny </p>
            <br />
            <p className="text8">
              Professor <br /> Department of Plant Systematics, Ecology
              and Theoretical Biology, ELTE
            </p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
              The occurrence of tree species in high mountains usually
              ends abruptly at some elevation. This is the treeline.
              Magnifying this region, we find a characteristic
              ‘mainland/island’ structure, in which the tree cover is
              continuous at lower elevations (‘mainland’), and gets
              fragmented at higher ones (‘islands’). Theoretical
              considerations from percolation theory suggest that the hull
              of the ‘mainland’ should be a fractal with dimension 7/4.
              The task is to test this hypothesis using satellite images
              of treelines. The main goal is to suggest a feasible method
              for characterising the fractal structure of treelines,
              taking into account the limitations of real-life ecological
              data. The method’s potential applications include the
              precise delineation of species borders, and thus the
              detection of population shifts due to climate change. <br />
              <br />
              Related literature:{" "}
              <ul>
                <li>
                  Gastner, M., Oborny, B., Pruessner, G. & Zimmermann, D.
                  (2009) Transition from connected to fragmented
                  vegetation across an environmental gradient: scaling
                  laws in ecotone geometry.
                  <span className="text9"> American Naturalist </span> 174:
                  23-39.{" "}
                </li>
                <br />{" "}
                <li>
                  Juhász R., Oborny B. (2020) Percolation theory suggests
                  some universal features in range margins across
                  environmental gradients.{" "}
                  <span className="text9"> Ecological Complexity </span>
                  42, 100814.
                </li>{" "}
              </ul>
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default PreviousCard6;
